(() => {
  const root = document.querySelector('.creator-reward-page');
  if (!root) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });

  root.querySelectorAll('.section-head, .steps, .notes, .reward-table, .faq-list, .faq-disclaimer, .form-grid').forEach(el => {
    el.classList.add('reveal');
    io.observe(el);
  });

  root.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        root.querySelectorAll('.faq-item').forEach(other => {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  const sourceSelect = root.querySelector('#product-source');
  const orderField = root.querySelector('#order-field');
  const orderInput = root.querySelector('#order');

  if (sourceSelect && orderField && orderInput) {
    const syncOrderField = () => {
      const shouldShowOrder = sourceSelect.value === 'Purchased by myself';
      orderField.hidden = !shouldShowOrder;
      orderInput.disabled = !shouldShowOrder;
      orderInput.required = shouldShowOrder;
      if (!shouldShowOrder) orderInput.value = '';
    };

    sourceSelect.addEventListener('change', syncOrderField);
    syncOrderField();
  }
})();
